import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { Storage } from '@ionic/storage-angular';

const routes: Routes = [
  {
    path: 'start/:token',
    loadChildren: () => import('./start-page/start-page.module').then( m => m.StartPageModule)
  },
  {
    path: ':pathname',
    loadChildren: () => import('./multi-step-form/multi-step-form.module').then( m => m.MultiStepFormPageModule)
  },
  {
    path: '',
    redirectTo: 'start',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule],
  providers: [Storage]
})
export class AppRoutingModule { }
